import { useEffect, useState } from "react";
import { defaultEventPersonalization, getEventPersonalization } from "./api";
import type { EventPersonalization } from "./types";

export function useEventPersonalization(clientSlug?: string, eventSlug?: string) {
  const [event, setEvent] = useState<EventPersonalization | null>(() =>
    clientSlug && eventSlug ? defaultEventPersonalization(clientSlug, eventSlug) : null,
  );

  useEffect(() => {
    if (!clientSlug || !eventSlug) return;
    let active = true;
    setEvent(defaultEventPersonalization(clientSlug, eventSlug));
    void getEventPersonalization(clientSlug, eventSlug)
      .then((result) => {
        if (active) setEvent(result);
      })
      .catch(() => {
        if (active) setEvent(defaultEventPersonalization(clientSlug, eventSlug));
      });
    return () => {
      active = false;
    };
  }, [clientSlug, eventSlug]);

  return event;
}
